import { LOGO_FINDER_COLS, LOGO_FINDER_GAPS } from "../contants";

export const LogoFinderSkeleton = () => {
  return (
    <ul
      className="tw-m-0 tw-grid tw-size-full tw-list-none tw-overflow-hidden"
      style={{
        gridTemplateColumns: `repeat(${LOGO_FINDER_COLS}, 1fr)`,
        gap: LOGO_FINDER_GAPS,
      }}
    >
      {Array.from({ length: 16 }, (_, idx) => (
        <li
          key={idx}
          className="tw-h-[196px] tw-w-full tw-rounded-lg tw-bg-blue-50"
        />
      ))}
    </ul>
  );
};
